import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";

const ProductGroupList = (props: PickerListProps<server.dto.ProductGroupForList>) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListProductGroupInstruction>({
    page: 1,
    perPage: 20,
    keyword: ""
  });

  return <PickerList
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="productGroups"
    api={window.CoreApi.ProductGroup.Paginated}
    onItemSelected={props.onItemSelected}
    getError={() => undefined}
    excludeKeys={props.excludeKeys}
    getId={pg => pg.productGroupId}
    renderListItem={pg => <div>{pg.title}</div>}
  />;
};

export default ProductGroupList;